export default __webpack_public_path__ + "static/media/casino-chips-ico.734f926c.svg";